import localFun from '@/utils/local-ope';
import { Message } from 'element-ui';
import store from '@/store';
import JSEncrypt from 'jsencrypt';

const publicKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC11A7OmtK/kwnx4xihEPprykA1U6fALNoRgujWt/mPLMcYtXg+e2FomLrWTou7XrD7jvNld7KBZ/gMLHdcsARZ5wgcoSYR6Zilbhg91nX1sR+MgT9xP72F+8Pf12qYw/aHMc9DJeV0IvIE1VaHrNCn8nQSaKxBQt9UBauFzkAvqQIDAQAB`;
const TokenKey = 'sessionId';

export function getToken() {
  return localFun.get(TokenKey);
}
export function getAliasToken() {
  return localFun.get('tempSessionId');
}

export function setToken(token) {
  return localFun.set(TokenKey, token);
}
export function setAliasToken(token) {
  return localFun.set('tempSessionId', token);
}

export function removeToken() {
  return localFun.remove(TokenKey);
}

/**
 *  plateForm指代的都是大小后台
 */
const PlateForm = 'plateForm'; // 平台: 大、小后台

export const ROLES_ADMIN = true; // 管理员 大后台
export const ROLES_TENANT = false; // 租户 小后台

export function getPlateForm() {
  if (localFun.get(PlateForm) === 'false') {
    // 此时cookie为字符串
    return false;
  }
  return true;
}

export function setPlateForm(plateForm) {
  localFun.set(PlateForm, plateForm);
}

export function removePlateForm() {
  return localFun.remove(PlateForm);
}

export function getMobile() {
  return localFun.get('mobile');
}

const funcKey = 'func';
// 功能权限
export const VISIT_FUNC = 1; // 线下拜访 简称拜访1.0
export const VISIT_FUNC2 = 26; // 线下拜访2.0 简称拜访2.0
export const VISIT_PHARMACY = 41; // 巡店
export const ONLINE_VISIT_FUNC = 32; // 线上拜访
export const PUBLIC_FUNC = 9; // 公众号管理
export const WRITEOFF_FUNC = 3; // 核销管理
export const OFFLINE_FUNC = 4; // 签到记录原线下会议签到
export const DATA_FUNC = 11; // 资料库 && 资料统计
export const SESSION_RETAINED_FUNC = 12; // 会话留存
export const TRAINING_MANAGEMENT_FUNC = 15; // 培训管理
export const TEST_MANAGEMENT_FUNC = 16; // 试卷管理
export const WECHAT_HOME_CONFIG_FUNC = 19; // 首页配置
export const SCHEDULE_MANAGEMENT = 13; // 日程管理
export const ADMISSION_MANAGEMENT = 37; //进院管理1.0
export const ADMISSION_MANAGEMENT_ALS = 66; //进院管理2.0
export const PROMOTE_FUNC = 17; // 活动推广管理
export const SAAS_FUNC = 5; // saas任务管理
export const OFFLINE_MEET_FUNC = 20; // 会议原线下会议
export const POINTS_MANAGE_FUNC = 21; // 积分管理
export const POINTS_MALL_FUNC = 22; // 积分商城
export const AUTHENTICATION_FUNC = 23; // 用户认证信息
export const QUESTIONNAIRE_FUNC = 27; //调研问卷
export const FLOW_MANAGEMENT_FUNC = 28; // 流向管理
export const Y_DATA_FUNC = 31; //y-data
export const QYWXGL_MODE_FIRST_OA_THEN_DB = 10000; // 企业微信管理租户1.0（前端根据后台返回的租户模式判断菜单的显示隐藏）
export const NOTICE_FUNC = 35;
export const SERVICER_TASK_CODE = 43; // 服务商
export const MINE_DAILY_REPORT = 44; // 我的日报
export const TEAM_DAILY_REPORT = 45; // 团队日报
export const ACCOUNT_MANAGE_FUNC = 40; //企业积分商城
export const NO_SALE_MY_CUSTOMER = 69; //非销-我的客户
export const NO_SALE_MY_ORG = 70; //非销-我的机构
export const ALL = 3; // 客户和用户
export const CUSTOMER = 1; // 客户
export const USER = 2; // 用户
export const APPROVAL_CONFIGURATION = 74; //审批配置1.0
export const APPROVAL_CONFIGURATION_TWO = 75; //审批配置2.0

export function getFunc() {
  return JSON.parse(localFun.get(funcKey));
}

export function setFunc(func) {
  localFun.set(funcKey, JSON.stringify(func));
}

export function beforeAvatarUpload(file) {
  var FileExt = file.name.replace(/.+\./, '');
  if (['xlsx', 'xls'].indexOf(FileExt.toLowerCase()) === -1) {
    Message({
      message: '选择的文件不是.xls或.xlsx的文件，请重新选择',
      type: 'error',
      duration: '2000'
    });
    return false;
  }
  return true;
}

export function removeFunc() {
  return localFun.remove(funcKey);
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
export function hasPermission(userRoles, routerRoles) {
  return routerRoles.includes(userRoles);
}

/**
 *
 * @param {*} userRoles
 * @param {*} routerRoles
 */
export function hasMenuPermission(item) {
  const { meta } = item;
  if (meta && meta.roles && meta.roles.length > 0) {
    return meta.roles.includes(getPlateForm());
  }

  return true;
}

// 小后台查询字段tab

export const fieldList = [
  {
    name: '医院客户',
    type: 'HOSPITAL_CUSTOMER',
    id: 'HOSPITAL',
    title: '医院客户',
    showIndex: true
  },
  {
    name: '经销商客户',
    type: 'DEALER_CUSTOMER',
    id: 'DEALER',
    title: '经销商客户',
    showIndex: false
  },
  {
    name: '主管单位客户',
    type: 'COMPETENT_AUTHORITY_CUSTOMER',
    id: 'COMPETENT_AUTHORITY',
    title: '主管单位客户',
    showIndex: false
  },
  {
    name: '药店客户',
    type: 'PHARMACY_CUSTOMER',
    id: 'PHARMACY',
    title: '药店客户',
    showIndex: false
  },
  {
    name: '产品',
    type: 'PRODUCT',
    title: '产品',
    showIndex: false
  },
  {
    name: '医院',
    type: 'HOSPITAL',
    id: 'HOSPITAL',
    title: '医院',
    showIndex: false
  },
  {
    name: '经销商',
    type: 'DEALER',
    id: 'DEALER',
    title: '经销商',
    showIndex: false
  },
  {
    name: '主管单位',
    type: 'COMPETENT_AUTHORITY',
    id: 'COMPETENT_AUTHORITY',
    title: '主管单位',
    showIndex: false
  },
  {
    name: '药店',
    type: 'PHARMACY',
    id: 'PHARMACY',
    title: '药店',
    showIndex: false
  }
];

// 培训管理模块相关字段
//#region
//上一页
export const TRAIN_PLAN_UP = 'up';
//下一页
export const TRAIN_PLAN_NEXT = 'next';
//发布
export const TRAIN_PLAN_PUBLISH = 'publish';
//培训计划
export const TRAIN_TYPE_TRAINING_PLAN = 'TRAINING_PLAN';
//考试计划
export const TRAIN_TYPE_EXAM_PLAN = 'EXAM_PLAN';
export const TRAIN_TYPE_ONLINE_TRAINING_PLAN = 'ONLINE_TRAINING_PLAN';
// 富文本编辑器顶部菜单配置
export const TRAIN_TYPE_TINYMCE = [
  'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript',
  'hr bullist numlist preview forecolor backcolor'
];

//
export const TRAINING_MANAGEMENT = 'TRAINING_MANAGEMENT';

//#endregion

//上传文件枚举值
export const uploadFileEnum = {
  TRAIN: 'train', //培训
  EXAM: 'exam', //考试
  COURSE: 'course', //课程
  CONFIG: 'config', //系统配置相关
  POINTS_MALL: 'points-mall', //积分商城
  QUESTIONNAIRE: 'questionnaire', //问卷
  MEETING: 'meeting', //会议
  DATABASE: 'database', //资料库
  UPLOADING_CENTER: 'uploading_center', //导入中心
  SERVICER: 'servicer', //服务商
  CUSTOMERSERVICEASSISTANT: 'customer-service-assistant', //客服助手
  SPEAKER: 'speaker', //讲者
  COST_CENTER: 'cost_center', // 成本中心
  INDICATOR: 'indicator', //指标
  STRUCTURE: 'structure', //架构
  MASTERDATA: 'masterData', //主数据 // 后续主数据相关都放在这个目录下
  SIGNIN: 'signIn', //签到
  MONTHLY_INVENTORY: 'monthly-inventory', //月度库存
  STOCK_REPORT: 'stock_report', //库存上报
  BONUS_MANAGEMENT: 'bonus-management', //奖金管理
  CONTRACT: 'contract', //合约
  DISTRIBUTION_ORG: 'distribution-org', //配送单位
  WAREHOUSE_ORG: 'warehouse-org', //仓库管理
  ORDER_MANAGEMENT: 'order-management', //订单管理
  BID_PRICE_MANAGEMENT: 'bid-price-management', //中标价
  INVOICE_UPLOAD: 'invoice-upload', // 开票管理
  MARGIN_MANAGEMENT: 'margin-management', // 保证金管理
  SPECIAL_REWARDS_DEDUCTIONS: 'special-rewards-deductions', // 特殊奖励和罚扣
  THIRD_PARTY_DATA: 'third-party-data' // 第三方数据
};

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encodeURIComponent(encryptor.encrypt(txt));
}

/**
 * 校验是否拥有权限 多用于v-if
 * @param {*} permission
 * @returns
 */
export const checkUserPermission = (permission) => {
  if (typeof permission == 'boolean') {
    return permission;
  }
  return store.state.app.permissionCodes.includes(permission);
};
